import * as React from 'react'
import { useRecentStoriesData } from '@features/stories/hooks/useRecentStoriesData'
import { StoriesScrollView } from './StoriesScrollView/StoriesScrollView'

export function StoriesWidget() {
  const recentStories = useRecentStoriesData()

  return <StoriesScrollView {...recentStories} />
}
